export default {
  page_title: 'Refills',
  page_description: 'Manage consumable resource refills',
  add_refill: 'Add Refill',
  edit_refill: 'Edit Refill',
  editTitle: 'Edit Refill',
  resource: 'Resource',
  user: 'User',
  quantity_added: 'Quantity Added',
  refilled_date: 'Refilled Date',
  current_quantity: 'Current Quantity',
  notes: 'Notes',
  notes_placeholder: 'Enter any notes about this refill...',
  quantity_to_add: 'Quantity to Add',
  add: 'Add',
  edit: 'Edit',
  added_successfully: 'Refill added successfully',
  updated_successfully: 'Refill updated successfully',
  invalid_quantity: 'Quantity must be greater than 0',
  unknown_resource: 'Unknown Resource',
  unknown_user: 'Unknown User',
  units: 'units'
};
